// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__189RW","header":"PatientQuestionnaire_header__2jVFX","info":"PatientQuestionnaire_info__1VyuV"};